<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white"> Please Wait...Image is Uploading </p>
</ngx-spinner>
<div class="header_second">
    <div class="Dashboard_head">Card Design
        <div>
            <button class="me-2" mat-raised-button color="primary"
                (click)="custom_card()"><mat-icon>mode_edit</mat-icon>Custom</button>
            <button class="me-2" mat-raised-button style="background: green;color: white;"
                (click)="Update_Card()"><mat-icon>save</mat-icon>Save</button>
        </div>
    </div>
</div>

<div class="m-3">
    <mat-label>Upload Image :</mat-label>
    <input type="file" #file class="form-control" id="inputGroupFile02" accept="image/png, image/jpeg, image/jpg "
        (change)="previewpimage(file.files)">
</div>

<div class="container">
    <div class="row">
        <div class="col-lg-6 col-xl-4 col-md-12 mb-5">
            <app-card1 [isSelected]="selectedCard === 'card1'" (click)="selectCard('card1')">></app-card1>
        </div>
        <div class="col-lg-6 col-xl-4 col-md-12 mb-5">
            <app-card2 [isSelected]="selectedCard === 'card2'" (click)="selectCard('card2')">></app-card2>
        </div>
        <div class="col-lg-6 col-xl-4 col-md-12 mb-5">
            <app-card3 [isSelected]="selectedCard === 'card3'" (click)="selectCard('card3')">></app-card3>
        </div>
    </div>
</div>